<template>
  <v-system-bar v-if="urgentNotification?.enabled" class="text-body-2" :color="notificationValue?.color">
    <v-container class="d-flex ga-2 justify-center text-center">
      <span v-if="description">
        {{ description }}
      </span>

      <a v-if="link && link.isVisible" class="align-center d-flex" :href="link.href" target="_blank" :title="link.title">
        {{ link.title }}
      </a>
    </v-container>
  </v-system-bar>
</template>

<script lang="ts" setup>
import { useFlags } from 'flagsmith-vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useFlagValue } from '@abaninja/util-flagsmith';
import { createTranslations } from '@abaninja/util-locale';

const { locale } = useI18n();

const { urgent_notification: urgentNotification } = useFlags(['urgent_notification']);

const notificationValue = useFlagValue(urgentNotification, {
  json: true,
  fallback: {
    color: '',
    ...createTranslations({
      description: '',
      link: {
        href: '',
        isVisible: false,
        title: '',
      },
    }),
  },
});

const description = computed(() => notificationValue.value
  ? notificationValue.value[locale.value as 'de' | 'en' | 'fr' | 'it'].description
  : '');

const link = computed(() => notificationValue.value
  ? notificationValue.value[locale.value as 'de' | 'en' | 'fr' | 'it'].link
  : null);
</script>

<style lang="postcss" scoped>
a {
  color: inherit;
}
</style>
